// Source: dadosfera/beast v9.1.0, theme/styles/themes/_default.scss.
// Keep this React adapter aligned with the official theme; no Angular runtime is required.
export const beastTokens = {
  brand: {
    primary: '#1700a2', primaryDark: '#14008a', primaryLight: '#eeebff',
    secondary: '#4db04f', secondaryDark: '#388e3c', secondaryLight: '#edf7ed',
    info: '#3bbff0', success: '#4db04f', warning: '#ff9800', danger: '#ef4444',
  },
  neutral: {
    0: '#ffffff', 50: '#f9f9f9', 100: '#f2f2f2', 200: '#eeeeee', 300: '#dfdfdf',
    400: '#c8c8c8', 500: '#737373', 600: '#5c5c5c', 700: '#333333', 800: '#262626', 900: '#151515',
  },
  fontFamily: 'Quicksand, "Open Sans", sans-serif',
  radius: { sm: 4, md: 4, lg: 8 },
  shadow: {
    xs: '0 1px 3px rgba(0,0,0,0.06)', sm: '0 2px 8px rgba(0,0,0,0.08)',
    md: '0 2px 8px rgba(0,0,0,0.10)', lg: '0 2px 8px rgba(0,0,0,0.12)',
  },
};
export default beastTokens;
